import { render, staticRenderFns } from "./PaginationSimpleComponent.vue?vue&type=template&id=4a21006e&scoped=true&"
import script from "./PaginationSimpleComponent.vue?vue&type=script&lang=js&"
export * from "./PaginationSimpleComponent.vue?vue&type=script&lang=js&"
import style0 from "./PaginationSimpleComponent.vue?vue&type=style&index=0&id=4a21006e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a21006e",
  null
  
)

export default component.exports